var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 17C34 26.389 26.389 34 17 34C7.61096 34 0 26.389 0 17C0 7.61096 7.61096 0 17 0C26.389 0 34 7.61096 34 17Z",
    fill: "#F43E37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.77783 17.0001C3.77783 9.69761 9.69761 3.77783 17.0001 3.77783C24.3025 3.77783 30.2223 9.69761 30.2223 17.0001H26.9167C26.9167 11.5232 22.4769 7.08339 17.0001 7.08339C11.5232 7.08339 7.08339 11.5232 7.08339 17.0001C7.08339 22.4769 11.5232 26.9167 17.0001 26.9167V30.2223C9.69761 30.2223 3.77783 24.3025 3.77783 17.0001ZM17.0001 24.9334C12.6186 24.9334 9.06672 21.3815 9.06672 17.0001C9.06672 12.6186 12.6186 9.06672 17.0001 9.06672C21.3815 9.06672 24.9334 12.6186 24.9334 17.0001H22.0485C22.0485 14.2119 19.7882 11.9516 17.0001 11.9516C14.2119 11.9516 11.9516 14.2119 11.9516 17.0001C11.9516 19.7882 14.2119 22.0485 17.0001 22.0485V24.9334Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3192d859.svg";
export { ForwardRef as ReactComponent };